module.exports = __webpack_public_path__ + "static/media/instagramBlack.498996fb.svg";